import React, { RefObject, useEffect, useRef, useState } from "react";

export function isElementScrollableRight(element: RefObject<HTMLDivElement>): boolean {
  if (element?.current) {
    return element.current?.scrollWidth > element.current?.clientWidth + element.current?.scrollLeft;
  }
  return false;
}

export const useHandleScroll = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const containerRef = useRef<HTMLDivElement | null>(null);

  function handleScroll() {
    const position = containerRef.current?.scrollLeft || 0;
    setScrollPosition(position);
  }

  useEffect(() => {
    const container = containerRef.current;
    container?.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { scrollRef: containerRef, scrollPosition };
};
